var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attachment-item" }, [
    _vm.isImage
      ? _c(
          "div",
          { staticClass: "image-preview", on: { click: _vm.openAttachment } },
          [
            _c("img", {
              attrs: { src: _vm.getAttachmentUrl(), alt: "Görsel önizleme" },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "attachment-info", on: { click: _vm.openAttachment } },
      [
        !_vm.isImage
          ? _c("div", { staticClass: "attachment-icon" }, [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.getAttachmentIcon())),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "attachment-details" }, [
          _c("div", { staticClass: "attachment-name" }, [
            _vm._v(_vm._s(_vm.attachment.name || "unnamed")),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "attachment-size" }, [
            _vm._v(_vm._s(_vm.formatFileSize)),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "attachment-actions" }, [
      _c(
        "a",
        {
          attrs: {
            href: _vm.getAttachmentUrl(),
            download: _vm.attachment.name || "unnamed",
            target: "_blank",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("a-button", { attrs: { type: "link", size: "small" } }, [
            _c(
              "i",
              {
                staticClass: "material-icons",
                staticStyle: { "font-size": "18px" },
              },
              [_vm._v("download")]
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }